<template>
  <v-dialog
    transition="dialog-bottom-transition"
    max-width="600"
    v-model="dialog"
  >
    <template>
      <v-card>
        <v-toolbar
          color="primary"
          dark
        >

          <v-btn
            @click="handleClose"
            style="margin-right: 20px;"
          >Cerrar</v-btn>
        </v-toolbar>
        <v-card-text style="padding-top: 10px;">
        <v-card 
          v-for="(error, index) of errors"
          :key="index"
          style="margin-bottom: 5px;padding:5px 10px;"
        >
          <p>{{error.Time}}</p>
          <p>[{{error.Code}}] - {{error.Description}}</p>
        </v-card>
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn
            text
            @click="handleClose"
          >Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </template>
  </v-dialog>
</template>
<script>
import axios from 'axios'
export default {
  props: {
    apiURL: {
      type: String,
      required: true,
    },
    network: {
      type: String,
      default: null,
    },
    deviceID: {
      type: Number,
      default: null,
    },
    onClose: {
      type: Function,
      required: true,
    },
  },
  data: () => ({
    dialog: false,
    errors: [],
  }),
  watch: {
    network () {
      if (this.dialog) this.handleClose()
    },
    deviceID (v) {
      this.dialog = v
      if (v) this.handleGetErrors()
    },
  },
  methods:{
    convertTime(v) {
      const dt = new Date(v)
      const result = `${
              dt.getDate().toString().padStart(2, '0')}/${
              (dt.getMonth()+1).toString().padStart(2, '0')}/${
              dt.getFullYear().toString().padStart(4, '0')} ${
              dt.getHours().toString().padStart(2, '0')}:${
              dt.getMinutes().toString().padStart(2, '0')}:${
              dt.getSeconds().toString().padStart(2, '0')}`

      return result === '01/01/0001 00:00:00' ? '' : result
    },
    handleClose () {
      this.errors = []
      this.onClose()
    },
    handleGetErrors () {
      this.errors = []
      if (!this.deviceID || !this.network) return
      axios.get(`${this.apiURL}/v1/private/brightsign/${this.network}/devices/${this.deviceID}/errors?token=${localStorage.getItem('jwt')}`)
        .then (response => {
          this.errors = response.data.map(item => {
            item.Time = this.convertTime(item.Time)
            return item
          })
        })
        .catch (error => {
          console.log(error)
        })
    },
  },
}
</script>

